import("./bootstrap")
  .then(res => console.log("Loaded"))
  .catch(e => {
    console.log("bootstrap.js import error",e)
  });